function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component, Fragment } from 'react';
import numeral from 'numeral';
import moment from 'moment';
import Link from 'Pure/Link';
import Loader from 'Pure/Loader';
import { front_urls, URL } from 'Shared/Routes';
numeral.locale('en');
moment.locale('fr');
export default class CompanyRow extends Component {
  state = {
    loading: false,
    status_messages: {}
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const {
      data,
      blank = false,
      fields
    } = props;
    const blank_props = blank === true ? {
      target: '_blank',
      rel: 'noopener noreferrer'
    } : {};
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-carbon']
    }) : undefined;
    const link = /*#__PURE__*/React.createElement(Link, _extends({
      className: "u-link-only"
    }, blank_props, {
      href: URL('AdminCompaniesDashboard', front_urls) + '/' + data.id
    }), "Fiche de l'entreprise");
    let output = /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell User-login"
    }, data.name, link), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell User-login"
    }, data.contact.lastname + " " + data.contact.firstname, link), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell User-login"
    }, data.phone_number, link), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell User-login"
    }, data.login, link));
    return output;
  }
}
